<template>
  <v-container>
    <v-form>
      <v-layout justify-center>
        <v-container>
          <v-layout>
            <v-flex>
              <boton-capacitacion></boton-capacitacion>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex></v-flex>
          </v-layout>
          <v-layout> </v-layout>
        </v-container>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import BotonCapacitacion from "@/modules/configuration/commonsviews/BotonesProcesoCapacitacion.vue";

export default {
  components: {
    BotonCapacitacion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    contratoId: "",
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.$store.commit("tab_state", "Proceso");
  },
  methods: {},
};
</script>
